import { render, staticRenderFns } from "./TokenExpirationModal.vue?vue&type=template&id=64bc4ed7"
import script from "./TokenExpirationModal.vue?vue&type=script&lang=js"
export * from "./TokenExpirationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bc4ed7')) {
      api.createRecord('64bc4ed7', component.options)
    } else {
      api.reload('64bc4ed7', component.options)
    }
    module.hot.accept("./TokenExpirationModal.vue?vue&type=template&id=64bc4ed7", function () {
      api.rerender('64bc4ed7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/TokenExpirationModal.vue"
export default component.exports